export var klona = function (evt) {
    return JSON.parse(JSON.stringify(evt));
};
//# sourceMappingURL=klona.js.map